var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { clearCustomRequest, customRequestApis, } from "../../../store/customRequest/actions";
import { useRequestState } from "./useRequestState";
var LIST_KEY = "getProductPaymentRecurrences";
var CREATE_KEY = "postProductPaymentRecurrence";
export var useProductPaymentRecurrences = function () {
    var dispatch = useDispatch();
    var list = useRequestState(LIST_KEY);
    var create = useRequestState(CREATE_KEY);
    var fetch = function (params) {
        dispatch(customRequestApis({
            requestKey: LIST_KEY,
            method: "GET",
            path: "/asg/Api/V1/PaymentModes",
            queryParams: __assign({}, params),
        }));
    };
    var createRecurrence = function (body) {
        dispatch(customRequestApis({
            requestKey: CREATE_KEY,
            method: "POST",
            path: "/asg/Api/V1/PaymentModes",
            body: { data: body },
        }));
    };
    useEffect(function () {
        return function () {
            dispatch(clearCustomRequest(LIST_KEY));
            dispatch(clearCustomRequest(CREATE_KEY));
        };
    }, []);
    return {
        fetch: fetch,
        create: createRecurrence,
        items: list.data,
        created: create.data,
        loadingCreate: create.loading,
        errorList: list.error,
        errorCreate: create.error,
        clearCreated: function () { return dispatch(clearCustomRequest(CREATE_KEY)); },
    };
};
